import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import Spinner from '../spinner';

import './loading-overlay.scss';

const LoadingOverlay: React.FC = () => {
    if (document) {
        const delay = 200;
        const [showLoading, setshowLoading] = useState(false);

        useEffect(() => {
            const timer = setTimeout(() => setshowLoading(true), delay);

            return (
                (): void => {
                    clearTimeout(timer);
                }
            );
        });

        return ReactDOM.createPortal(showLoading && (
            <div className="loading-overlay">
                <Spinner />
            </div>
        ), document.body);
    }

    return null;
};

export default LoadingOverlay;
